import { createContext } from "react";
import { CategoryStore } from "@/stores/CategoryStore";
import { PodcastStore } from "@/stores/PodcastStore";
import { SearchStore } from "@/stores/SearchStore";
import { PlayerStore } from "@/stores/PlayerStore";
import { EpisodeStore } from "@/stores/EpisodeStore";
import { AuthorStore } from "@/stores/AuthorStore";
import { UserStore } from "@/stores/UserStore";
import { LanguageStore } from "@/stores/LanguageStore";
import { AppStore } from "@/stores/AppStore";
import { SubjectStore } from "@/stores/SubjectStore";
import { AdStore } from "@/stores/AdStore";
import { CollectionStore } from "@/stores/CollectionStore";
import { PlaylistStore } from "@/stores/PlaylistStore";
import { ToplistStore } from "@/stores/ToplistStore";
import { AuthStore } from "@/stores/AuthStore";
import { FollowsStore } from "@/stores/FollowsStore";
import { ListeningStore } from "@/stores/ListeningStore";
import { SleepTimerStore } from "@/stores/SleepTimerStore";
import { createClient } from "@/core/helpers";
import { createAuthorsApi } from "@/api/authors";
import { createCategoriesApi } from "@/api/categories";
import { createSearchApi } from "@/api/search";
import { createTrackingApi } from "@/api/tracking";
import { createCollectionsApi } from "@/api/collections";
import { createEpisodesApi } from "@/api/episodes";
import { createPodcastsApi } from "@/api/podcasts";
import { createSubjectsApi } from "@/api/subjects";
import { createToplistApi } from "@/api/toplist";

// One client for the catalogue stores: they share its cache and its in-flight requests
const catalogueClient = createClient();
const podcastStore = new PodcastStore(createPodcastsApi(catalogueClient));
const categoryStore = new CategoryStore(createCategoriesApi(catalogueClient));
// Categories are needed on most pages (autolinking), so start loading them right away
void categoryStore.preload();
const subjectStore = new SubjectStore(createSubjectsApi(catalogueClient));
const searchStore = new SearchStore(createSearchApi(catalogueClient));
const trackingApi = createTrackingApi(catalogueClient);
export const playerStore = new PlayerStore(trackingApi);
const episodeStore = new EpisodeStore(createEpisodesApi(catalogueClient));
const authorStore = new AuthorStore(createAuthorsApi(catalogueClient));
const userStore = new UserStore(createEpisodesApi(catalogueClient), createPodcastsApi(catalogueClient), trackingApi);
const languageStore = new LanguageStore(createPodcastsApi(catalogueClient), createEpisodesApi(catalogueClient));
const appStore = new AppStore();
const adStore = new AdStore();
const collectionStore = new CollectionStore(createCollectionsApi(catalogueClient));
const toplistStore = new ToplistStore(createToplistApi(catalogueClient));
export const authStore = new AuthStore();
const playlistStore = new PlaylistStore(createClient(), authStore);
export const followsStore = new FollowsStore(createClient(), authStore);
export const listeningStore = new ListeningStore(createClient(), authStore);
export const sleepTimerStore = new SleepTimerStore();

export const stores = createContext({
    podcastStore,
    categoryStore,
    searchStore,
    playerStore,
    episodeStore,
    authorStore,
    userStore,
    languageStore,
    appStore,
    subjectStore,
    adStore,
    collectionStore,
    playlistStore,
    toplistStore,
    authStore,
    listeningStore,
    followsStore,
    sleepTimerStore,
});
